import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import { GoogleMap } from '@react-google-maps/api';
import { Button } from 'antd';
import DropMenu from 'components/Basic/DropMenu';
import Marker from 'components/Basic/Marker';
import { FormattedMessage, injectIntl } from 'react-intl';
import LocationSearchInput from 'components/Basic/LocationSearchInput';
import { getLocations } from 'utilities/common';
import SearchIcon from '@material-ui/icons/Search';

const distances = [1, 2, 3, 4, 5];

class RestaurantMap extends PureComponent {
  constructor(props) {
    super(props);
    this.circle = null;
    this.map = null;
    this.state = {
      distance: props.restaurantInfo?.geoFence || 0,
      isVisisbleSearch: false,
      fullScreenOpen: false,
    };

    this.floatingAmbassadors = [
      props.intl.formatMessage({ id: 'Allow floating driver' }),
      props.intl.formatMessage({ id: "Don't allow floating driver" }),
    ];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.restaurantInfo?.geoFence !== this.props.restaurantInfo?.geoFence) {
      this.updateGeoFence();
    }
  }

  updateGeoFence = () => {
    const geoFence = this.props.restaurantInfo?.geoFence || 0;
    this.setState({ distance: geoFence });
    if (this.circle && this.map) {
      this.circle.setRadius(geoFence * 1000);
      const position = this.map.getCenter();
      if (position && typeof position.toJSON === 'function') {
        this.circle.setCenter(position.toJSON());
      }
    }
  };

  handleGoogleAPILoaded = map => {
    const { restaurantInfo } = this.props;
    const maps = window.google.maps;
    this.map = map;
    this.circle = new maps.Circle({
      radius: (this.props.restaurantInfo?.geoFence || this.state.distance) * 1000,
      center: {
        lat: restaurantInfo.lat || getLocations().lat,
        lng: restaurantInfo.long || getLocations().lng,
      },
      map,
      fillColor: '#FF2527',
      fillOpacity: 0.160238,
      strokeColor: '#FF2527',
    });

    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
    document.addEventListener('MSFullscreenChange', this.onFullscreenChange);
  };

  onFullscreenChange = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      this.setState({ fullScreenOpen: true });
    } else {
      this.setState({ fullScreenOpen: false });
    }
  };

  handleDistance = key => {
    const { restaurantInfo } = this.props;
    const distanceValue = distances[key];
    if (restaurantInfo?.lat && restaurantInfo?.long) {
      this.setState({ distance: distanceValue }, () => {
        if (this.circle) {
          this.circle.setRadius(this.state.distance * 1000);
        }
      });
      this.props.onChange('geoFence', distanceValue);
    }

    if (this.circle && this.map) {
      const position = this.map.getCenter();
      this.setState({ distance: distanceValue });
      this.circle.setRadius(distanceValue * 1000);
      if (position && typeof position.toJSON === 'function') {
        this.circle.setCenter(position.toJSON());
      }
    }
  };

  handleFloatingAb = key => {
    this.props.onChange(
      'floatingAmbassador',
      this.floatingAmbassadors[key] === this.props.intl.formatMessage({ id: 'Allow floating driver' }),
    );
  };

  handleDrag = async () => {
    const position = this.map?.getCenter();
    if (this.circle) {
      if (position && typeof position.toJSON === 'function') {
        this.circle.setCenter(position.toJSON());
      }
    }

    const coords = position && typeof position.toJSON === 'function' ? position.toJSON() : { lat: null, lng: null };
    const { lat, lng } = coords;

    if (lat == null || lng == null) {
      this.props.onDragMap(coords, '');
      return;
    }

    if (this.props.fetchAddress && typeof this.props.fetchAddress === 'function') {
      try {
        const address = await this.props.fetchAddress(lat, lng);
        this.props.onDragMap(coords, address);
      } catch (e) {
        console.error('Error fetching address:', e);
        this.props.onDragMap(coords, '');
      }
    } else {
      this.props.onDragMap(coords, '');
    }
  };

  handleZoom = () => {
    const { restaurantInfo } = this.props;
    if (this.circle && this.map) {
      this.circle.setRadius(this.state.distance * 1000);
      if (restaurantInfo?.lat && restaurantInfo?.long) {
        this.map.setCenter({
          lat: restaurantInfo.lat,
          lng: restaurantInfo.long,
        });
        this.circle.setCenter({
          lat: restaurantInfo.lat,
          lng: restaurantInfo.long,
        });
      }
    }
  };

  showSearchBox = () => {
    this.setState(prev => ({ isVisisbleSearch: !prev.isVisisbleSearch }));
  };

  handleGeoInfo = (address, latLng) => {
    if (this.circle && this.map) {
      this.circle.setRadius(this.state.distance * 1000);
      this.circle.setCenter({
        lat: latLng.lat,
        lng: latLng.lng,
      });
      this.props.onDragMap(latLng, address);
    }
  };

  render() {
    const { restaurantInfo } = this.props;
    const { isVisisbleSearch, fullScreenOpen } = this.state;

    return (
      <div className="restaurant_map_layout">
        <div className="map_setting">
          <p className="title">
            <FormattedMessage id="Geo reference of the restaurant and ambassadors" />
          </p>
          <p className="description">
            <FormattedMessage id="Restaurant Map Description" />
          </p>
          <div className="geo_distance">
            <DropMenu
              items={distances}
              onMenu={key => this.handleDistance(key)}
              placeHolder="Geo-cerca a kilómetros"
              defaultValue={restaurantInfo?.geoFence ? restaurantInfo.geoFence : 0}
            />
          </div>
          <div className="geo_allow">
            <DropMenu
              items={this.floatingAmbassadors}
              onMenu={key => this.handleFloatingAb(key)}
              placeHolder="Permite embajadores flotantes"
              defaultValue={
                restaurantInfo?.floatingAmbassador
                  ? this.props.intl.formatMessage({ id: 'Allow floating driver' })
                  : this.props.intl.formatMessage({ id: "Don't allow floating driver" })
              }
            />
          </div>
        </div>

        <div className="map_wrapper">
          {isVisisbleSearch && <LocationSearchInput onGetGeoInfo={this.handleGeoInfo} />}

          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={{
              lat: restaurantInfo?.lat || getLocations().lat,
              lng: restaurantInfo?.long || getLocations().lng,
            }}
            zoom={11}
            onLoad={this.handleGoogleAPILoaded}
            onDragEnd={this.handleDrag}
            onZoomChanged={this.handleZoom}
          >
            <Marker
              lat={restaurantInfo?.lat || getLocations().lat}
              lng={restaurantInfo?.long || getLocations().lng}
            />
          </GoogleMap>

          <Button className="search_btn" onClick={this.showSearchBox}>
            <SearchIcon />
          </Button>
        </div>
      </div>
    );
  }
}

RestaurantMap.propTypes = {
  restaurantInfo: PropTypes.object,
  onChange: PropTypes.func,
  onDragMap: PropTypes.func,
  fetchAddress: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

RestaurantMap.defaultProps = {
  restaurantInfo: {},
  onChange: () => {},
  onDragMap: () => {},
  fetchAddress: async () => '',
};

export default compose(injectIntl)(RestaurantMap);
